import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Accordion, { AccordionItem } from '../@base/Accordion';
import TextArea from '../@base/TextArea';
import {
  getParameter, preparingInput, onValidHandler, handleInputValid,
} from './Commons';

import styles from './SharedStyle.module.css';

const EvaluationComponent = (props) => {
  if (!props.component.parameters) return null;

  const parameterList = props.component.parameters;

  const positiveMessage = getParameter(parameterList, 'assessment.like.answer');
  const negativeMessage = getParameter(parameterList, 'assessment.dislike.answer');
  const finalMessage = getParameter(parameterList, 'assessment.dislike.end.answer');

  positiveMessage.value = positiveMessage.value ? positiveMessage.value : '';
  negativeMessage.value = negativeMessage.value ? negativeMessage.value : '';
  finalMessage.value = finalMessage.value ? finalMessage.value : '';

  const [inputValid, setInputValid] = useState({});

  useEffect(() => {
    const helperContent = (
      <div>
        {ReactHtmlParser(`${props.component.description} Nesse componente podem ser configurados:`)}
        <ul>
          <li>{ReactHtmlParser(positiveMessage.parameter.hint)}</li>
          <li>{ReactHtmlParser(negativeMessage.parameter.hint)}</li>
          <li>{ReactHtmlParser(finalMessage.parameter.hint)}</li>
        </ul>
      </div>
    );
    props.setHelperContent(<div>{helperContent}</div>);
  }, []);

  useEffect(() => {
    handleInputValid(inputValid, props);
  }, [inputValid]);

  return (
    <Accordion>

      <AccordionItem active title={ReactHtmlParser(positiveMessage.parameter.hint)}>
        <div>Mensagem para a avaliação positiva</div>
        <div className={styles.ComponentSubList}>
          {preparingInput(
            <TextArea
              height={60}
              placeholder="Digite as regras"
            />, positiveMessage, props, onValidHandler(setInputValid, positiveMessage),
          )}
        </div>
      </AccordionItem>

      <AccordionItem active title={ReactHtmlParser(negativeMessage.parameter.hint)}>
        <div>Mensagem para a avaliação negativa</div>
        <div className={styles.ComponentSubList}>
          {preparingInput(
            <TextArea
              height={60}
              placeholder="Digite as regras"
            />, negativeMessage,
            props,
            onValidHandler(setInputValid, negativeMessage),
          )}
        </div>
      </AccordionItem>

      <AccordionItem active title={ReactHtmlParser(finalMessage.parameter.hint)}>
        <div>Agradecimento pelo feedback</div>
        <div className={styles.ComponentSubList}>
          {preparingInput(
            <TextArea
              height={60}
              placeholder="Digite as regras"
            />, finalMessage, props, onValidHandler(setInputValid, finalMessage),
          )}
        </div>
      </AccordionItem>
      {props.localizationAccordionItem || null}
    </Accordion>
  );
};

export default EvaluationComponent;
